import { useCallback, useState } from 'react';

import { Button, ButtonIcon } from '../button/button';
import { CustomFormattedMessage } from '../intl/custom-formatted-message';
import { Modal, ModalProps, ModalWidth } from './modal';

type ModalPromptProps = ModalProps & {
  confirmText?: JSX.Element | string;
  cancelText?: JSX.Element | string;
  onConfirm?: () => Promise<void> | void;
  onCancel?: () => void;
  onClose?: () => void;
};

export function ModalPrompt({
  width = ModalWidth.LARGE,
  confirmText,
  cancelText,
  onConfirm,
  onCancel,
  onClose,
  ...props
}: ModalPromptProps) {
  const [loading, setLoading] = useState<boolean>(false);

  const onHandleConfirm = useCallback(async () => {
    setLoading(true);

    await onConfirm?.();

    setLoading(false);

    onClose?.();
  }, [onConfirm, onClose]);

  const onHandleCancel = useCallback(() => {
    onCancel?.();

    onClose?.();
  }, [onCancel, onClose]);

  return (
    <Modal
      {...props}
      width={width}
      className="prompt"
      onClose={onClose}
      buttons={
        <>
          <Button
            testId={props.testId ? `${props.testId}.cancel` : undefined}
            onClick={onHandleCancel}
          >
            {cancelText ?? <CustomFormattedMessage id="common.no-go-back" />}
          </Button>
          <Button
            testId={props.testId ? `${props.testId}.confirm` : undefined}
            icon={loading ? ButtonIcon.LOADING : ButtonIcon.NONE}
            disabled={loading}
            inverted
            onClick={onHandleConfirm}
          >
            {confirmText ?? (
              <CustomFormattedMessage id="common.yes-go-further" />
            )}
          </Button>
        </>
      }
    />
  );
}
